// La ruta del modo Redes — ADR-2026-10-01-modo-redes. Sin `:sesionId` es la portada; con
// él, el lienzo de la sesión. Sólo escritorio (el lienzo lo es): en el teléfono la ruta
// avisa, como Diseño de indumentaria. Entrar no pide plan —como Prompt libre—; generar
// video lo pide adentro, al tocar Generar.

import { Monitor } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useEsEscritorio } from '../../../../chat-atlas/ui/useEsEscritorio';
import { PantallaRedes } from './PantallaRedes';

const RedesMode: React.FC = () => {
  const { sesionId } = useParams<{ sesionId?: string }>();
  const esEscritorio = useEsEscritorio();

  if (!esEscritorio) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
        <Monitor className="h-8 w-8 text-[#02062B]/[0.4]" aria-hidden="true" />
        <p className="text-[16px] font-semibold text-brand-black">Disponible en computadora</p>
        <p className="text-[14px] text-[#3C3C43]/60">Redes se usa desde una computadora: el lienzo necesita pantalla.</p>
      </div>
    );
  }
  return <PantallaRedes sesionId={sesionId} />;
};

export default RedesMode;
